import { uuidv7 } from './uuid.js';

const MESSAGE_TTL_MS = 7 * 24 * 60 * 60 * 1000;

function hashKey(str) {
    let hash = 2166136261;
    for (let i = 0; i < str.length; i += 1) {
        hash ^= str.charCodeAt(i);
        hash = (hash * 16777619) >>> 0;
    }
    return hash.toString(16);
}

export function createStorage(apiKey) {
    const namespace = 'mdd_chatbot_' + hashKey(apiKey);
    const sessionKey = namespace + '_session';
    const openKey = namespace + '_open';
    const messagesKey = namespace + '_messages';
    const presetsUsedKey = namespace + '_presets_used';

    function readStorage(key) {
        try {
            return window.localStorage.getItem(key);
        } catch (e) {
            return null;
        }
    }

    function writeStorage(key, value) {
        try {
            window.localStorage.setItem(key, value);
        } catch (e) {
            /* ignore */
        }
    }

    function removeStorage(key) {
        try {
            window.localStorage.removeItem(key);
        } catch (e) {
            /* ignore */
        }
    }

    function readMessages() {
        const raw = readStorage(messagesKey);
        if (!raw) return [];
        try {
            const parsed = JSON.parse(raw);
            if (!Array.isArray(parsed)) return [];
            const lastAt = parsed.length > 0 ? parsed[parsed.length - 1].at : 0;
            if (typeof lastAt === 'number' && Date.now() - lastAt > MESSAGE_TTL_MS) {
                removeStorage(messagesKey);
                removeStorage(presetsUsedKey);
                return [];
            }
            return parsed.filter(
                (m) => m && (m.role === 'user' || m.role === 'assistant') && typeof m.content === 'string'
            );
        } catch (e) {
            removeStorage(messagesKey);
            return [];
        }
    }

    return {
        getOrCreateSession() {
            let session = readStorage(sessionKey);
            if (!session) {
                session = uuidv7();
                writeStorage(sessionKey, session);
            }
            return session;
        },
        resetSession() {
            const next = uuidv7();
            writeStorage(sessionKey, next);
            return next;
        },
        getOpenState() {
            return readStorage(openKey) === 'true';
        },
        setOpenState(isOpen) {
            writeStorage(openKey, isOpen ? 'true' : 'false');
        },
        clearOpenState() {
            removeStorage(openKey);
        },
        getMessages() {
            return readMessages();
        },
        appendMessage(role, content) {
            if (role !== 'user' && role !== 'assistant') return;
            if (typeof content !== 'string' || content === '') return;
            const messages = readMessages();
            messages.push({ role, content, at: Date.now() });
            writeStorage(messagesKey, JSON.stringify(messages));
        },
        clearMessages() {
            removeStorage(messagesKey);
            removeStorage(presetsUsedKey);
        },
        markPresetsUsed() {
            writeStorage(presetsUsedKey, '1');
        },
        presetsUsed() {
            return readStorage(presetsUsedKey) === '1';
        },
    };
}
